import { render, staticRenderFns } from "./EmailEnquiryIcon.vue?vue&type=template&id=2bea3dd9&"
import script from "./EmailEnquiryIcon.vue?vue&type=script&lang=js&"
export * from "./EmailEnquiryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports